import { AltTransIncidentMeasurePlanStatus } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";
import { Badge, Skeleton } from "shared/components/Spor";
import { Nullish } from "shared/utils/objectUtils";

type EventHeaderStatusProps = {
  incidentMeasurePlanStatus: Nullish<AltTransIncidentMeasurePlanStatus>;
  incidentPlanLoadingState: "pending" | "success" | "error";
};

export const EventHeaderStatus: FC<EventHeaderStatusProps> = ({
  incidentMeasurePlanStatus,
  incidentPlanLoadingState,
}) => {
  if (incidentPlanLoadingState === "pending") {
    return <Skeleton width="12ch" height="5" />;
  }

  switch (incidentMeasurePlanStatus) {
    case "NOT_PUBLISHED":
      return <Badge semantic="warning">Upublisert tiltak</Badge>;

    case "PUBLISHED":
      return <Badge semantic="success">Publisert tiltak</Badge>;

    case "RETRACTED":
      return <Badge semantic="ghost">Tilbaketrukket tiltak</Badge>;

    case null:
    case undefined:
      // 404 from request, no matching plan found
      return <Badge semantic="alarm">Uten tiltak</Badge>;
  }
};
